import bee from "./Bee";
import utils from "./Utils";
export default {
    name: "Reports",    
    /*
        var query = {
            
        }
    */
    /* eslint-disable no-unused-vars */
    get_register_reports_dependencies(query, success, fail) {
        bee.get({
            districts: {
                cities: {},
                wards: {
                    streets: {}
                }
            },
            categories: {
                sub_categories: {}
            }
        }).then(res => {
            if (success) {
                success({
                    districts: res.districts,
                    categories: res.categories
                });
            }
        }).catch(errors => {
            if (fail) {
                fail(errors);
            }
        });
    },
    get_report(report_name,query, success, fail){
        var report_query = {
            _box: {
                ...query
            },
            _f_br: report_name
        }
        bee.get(report_query).then(res=> {
            if (success) {
                success(res.report_items);
            }
        }).catch(errors => {
            fail(errors);
        });
    },
    get_registrations_report(query, success, fail) {
        this.get_report("get_report_registrations",query, success, fail);
    },
    get_promotions_report(query, success, fail) {
        this.get_report("get_report_promotions",query, success, fail);
    },
    get_overdue_promotions_report(query, success, fail) {
        this.get_report("get_report_promotions_overdue",query, success, fail);
    },  
    get_views_promotions_report(query, success, fail){
        this.get_report("get_report_promotions_views", query, success, fail)
    },
    get_views_businesses_report(query, success, fail){
        this.get_report("get_report_businesses_views", query, success, fail)
    },
    get_searches_businesses_report(query, success, fail){
        this.get_report("get_report_businesses_searches", query, success, fail)
    },
    get_clicks_adverts_report(query, success, fail){
        this.get_report("get_report_advert_clicks", query, success, fail)
    },
    get_owners_promotions_report(query, success, fail) {
        this.get_report("get_report_owner_promotions",query, success, fail);
    },
    get_owners_overdue_promotions_report(query, success, fail) {
        this.get_report("get_report_owner_promotions_overdue",query, success, fail);
    }, 
    get_owners_views_businesses_report(query, success, fail){
        this.get_report("get_report_owner_businesses_views", query, success, fail)
    }, 
    get_owners_searches_businesses_report(query, success, fail){
        this.get_report("get_report_owner_businesses_searches", query, success, fail)
    },
    get_owners_reviews_businesses_report(query, success, fail){
        this.get_report("get_report_owner_businesses_reviews", query, success, fail)
    },
    get_owners_ratings_businesses_report(query, success, fail){
        this.get_report("get_report_owner_businesses_ratings", query, success, fail)
    },
}